import {useGetInfinitePatientLogs} from '@/modules/system-logs/api'
import {SystemLogsTable} from '@/modules/system-logs/components/system-logs-table'
import {Tabs} from '@chakra-ui/react'
import {Patient} from '@cypro/engine/schema'

export function PatientHistoryTab({patient}: {patient: Patient}) {
  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = useGetInfinitePatientLogs({
    patientId: patient.id,
  })

  return (
    <Tabs.Content value="history" spaceY="8" display="flex" flexDirection="column" flex="1" minHeight="0">
      <SystemLogsTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{}}
        hideBorder
        hidePatient
      />
    </Tabs.Content>
  )
}
